import React, { useContext, useEffect, useRef, useState } from "react";
import ChatInput from "../ChatInput/ChatInput";
import ReceiverMessage from "../ReceiverMessage/ReceiverMessage";
import SenderMessage from "../SenderMessage/SenderMessage";
import "./ChatArea.css";
import { ChatContext } from "../../../contexts/ChatContext";
import ChatServices, { fetchMessages } from "../../../services/ChatServices";
import { useQuery } from "react-query";
import {Delete} from '@mui/icons-material';
import { Box, Card, Grid, Typography } from "@mui/material";
import useRecorder from "../ChatInput/useRecorder";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import LetterAvatars from "../../Avatar";
import { socket } from '../Socket/Socket';
import LetterAvatarsecond from "../../AvatarSecond";
import { toast } from "react-toastify";
import DraftDialog from "../Dialog/DraftDialog";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ChatArea = () => {
  const { selectedContactId, userId, selectedGroupId, audioURL, showFilePage, audios, setAudios } = useContext(ChatContext);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [messageType, setMessageType] = useState("");
  const [disable, setDisable] = useState(false);
  const [latestMessage, setLatestMessage] = useState(null);
  const [AllMessage, setAllMessage] = useState([]);
  const [openDraftDialog, setOpenDraftDialog] = useState(false);
  const [from, setFrom] = useState('');
  const [audioIndex, setAudioIndex] = useState('');
  const dummy = useRef();

  useEffect(() => {
    if (dummy?.current) dummy.current.scrollIntoView({ behavior: "smooth" });
  }, [AllMessage, audios, selectedFile]);

  const isLoadingMsg = (
    <div className="chatarea">
      <div className="chatarea__container"></div>
      <div className="chatarea__messages"></div>
      <Grid container display='flex' flexDirection='row' justifyContent='center' alignItems="center" alignContent='center'>
        <Box py={2}>
          <Typography>
            Loading your latest messages. Sit tight, we're almost there!</Typography>
        </Box>
      </Grid>
    </div>
  );

  const isErrorMsg = (msg) => (
    <div className="chatarea">
      <div className="chatarea__container"></div>
      <div className="chatarea__messages"></div>
      <Grid container display='flex' flexDirection='row' justifyContent='center' alignItems="center" alignContent='center'>
        <Box py={2}>
          <Typography>
            "An error has occurred: " + {msg}
          </Typography>
        </Box>
      </Grid>
    </div>
  );

  const { data, error, isLoading, refetch } = useQuery(
    "contactMessages",
    async () => {
      if (selectedContactId && selectedContactId !== null) {
        const response = await ChatServices.fetchContactMessages(
          userId,
          selectedContactId
        );
        return response;
      }
      if (selectedGroupId && selectedGroupId !== null) {
        const response = await ChatServices.fetchGroupMessages(
          userId,
          selectedGroupId
        );
        return response;
      }
    },
    {
      enabled: !!selectedContactId || !!selectedGroupId,
      refetchOnWindowFocus: true,
    }
  );

  useEffect(() => {
    if (data) {
      setAllMessage(data.messages);
    }
  }, [data]);

  const handleReceiveMessage = (dataRe) => {
    if (dataRe) {
      setAllMessage(prevMessages => {
        const isDuplicate = prevMessages.some(message => message._id === dataRe._id);
        if (!isDuplicate) {
          return [...prevMessages, dataRe];
        }
        return prevMessages;
      });

      try {
        const response = ChatServices.markReadMsg(userId, selectedContactId);
        if (response.status === 200) {
          console.log('Message Read');
        } else {
          console.error("Error Opening Chat:", response.message);
        }
      } catch (error) {
        console.error("Error calling backend API:", error.message);
      }
    }
  };

  useEffect(() => {
    refetch();
  }, [selectedContactId, selectedGroupId]);

  useEffect(() => {
    if (audioURL && audioURL.data) {
      setAudios([audioURL]);
    }
  }, [audioURL]);

  if (isLoading) return isLoadingMsg;
  if (error) return isErrorMsg(error.message);

  // Define handleClose function
  const handleClose = () => {
    setOpenDraftDialog(false);
  };

  // Define deleteParticularMessage function
  const deleteParticularMessage = async (id) => {
    try {
      let response;
      if (!selectedGroupId && selectedGroupId === null) {
        response = await ChatServices.deleteMessage(userId, selectedContactId, id);
      } else {
        response = await ChatServices.deleteGroupMessage(userId, selectedGroupId, id);
      }
      if (response.status === 200) {
        await refetch();
      }
      else {
        console.error("Error Opening Chat:", response.message);
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
      toast.error(error.message);
    }
  }

  // Define HandleDialog function
  const HandleDialog = (item) => {
    setFrom(item);
    setOpenDraftDialog(true);
  };

  // Define Deletedata function
  const Deletedata = (id) => {
    const data = audios.filter((e, index) => {
      return index !== id;
    });
    setAudios(data);
    setSelectedFile(null)
    setSelectedFileName(null)
    setMessageType('')
    setDisable(false);
    handleClose();
  }

  const handleDeleteFileDraft = () => {
    setSelectedFile(null);
    setDisable(false);
    handleClose();
  }

  // const handleDownload = (base64Data, fileName, id) => {
  //   const element = document.createElement('a');
  //   const file = new Blob([base64Data], { type: 'application/octet-stream' });
  //   element.href = URL.createObjectURL(file);
  //   element.download = fileName;
  //   document.body.appendChild(element);
  //   element.click();
  //   document.body.removeChild(element);
  //   try {
  //     const response = ChatServices.markAsDownloaded(id, true);
  //     if (response.status === 200) {
  //       refetch();
  //     } else {
  //       console.error("Error Opening Chat:", response.message);
  //     }
  //   } catch (error) {
  //     console.error("Error calling backend API:", error.message);
  //   }
  // };


  const handleDownload = (base64Data, fileName, id) => {
  // Check if base64Data exists
  if (!base64Data || base64Data === 'undefined' || base64Data === 'null') {
    toast.error("File content is not available for download");
    return;
  }

  try {
    // Check if it's a valid base64 string
    if (typeof base64Data !== 'string') {
      toast.error("Invalid file format");
      return;
    }

    // Clean the base64 string (remove data URL prefix if present)
    let cleanBase64 = base64Data;
    if (base64Data.includes('base64,')) {
      cleanBase64 = base64Data.split('base64,')[1];
    }

    // Decode base64 to binary
    const binaryString = atob(cleanBase64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    
    // Determine file type from extension
    const fileExtension = fileName?.split('.').pop()?.toLowerCase() || '';
    const mimeTypes = {
      'pdf': 'application/pdf',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'png': 'image/png',
      'gif': 'image/gif',
      'txt': 'text/plain',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    };
    
    const mimeType = mimeTypes[fileExtension] || 'application/octet-stream';
    
    // Create blob and download
    const blob = new Blob([bytes], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || 'download';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Clean up
    URL.revokeObjectURL(url);
    
    // Mark as downloaded if id is provided
    if (id) {
      try {
        const response = ChatServices.markAsDownloaded(id, true);
        if (response.status === 200) {
          refetch();
          toast.success("File downloaded successfully!");
        } else {
          console.error("Error marking as downloaded:", response.message);
          toast.error("File downloaded but status not updated");
        }
      } catch (error) {
        console.error("Error calling markAsDownloaded API:", error.message);
        toast.success("File downloaded!");
      }
    } else {
      toast.success("File downloaded!");
    }
  } catch (error) {
    console.error("Error downloading file:", error);
    toast.error("Failed to download file. Please try again.");
  }
};

  // Helper function to check if message is from a different day
  const isDifferentDay = (currentDate, previousDate) => {
    if (!previousDate) return true;
    const current = new Date(currentDate);
    const previous = new Date(previousDate);
    return current.toDateString() !== previous.toDateString();
  };

  // Format date for display
  const formatDateHeader = (date) => {
    const messageDate = new Date(date);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (messageDate.toDateString() === today.toDateString()) {
      return 'Today';
    } else if (messageDate.toDateString() === yesterday.toDateString()) {
      return 'Yesterday';
    } else {
      return messageDate.toLocaleDateString('en-US', { 
        weekday: 'long', 
        month: 'short', 
        day: 'numeric' 
      });
    }
  };

  // Format time for display
  const formatMessageTime = (date) => {
    const messageDate = new Date(date);
    return messageDate.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: true 
    });
  };

  return (
    <>
      <DraftDialog
        openDraftDialog={openDraftDialog}
        setOpenDraftDialog={setOpenDraftDialog}
        from={from}
        handleClose={handleClose}
        Deletedata={() => Deletedata(audioIndex)}
        handleDeleteFileDraft={handleDeleteFileDraft}
      />
      {
        showFilePage ? (
          <Box sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}>
            <Box sx={{
              flex: 1,
              overflowY: 'auto',
              p: 2
            }}>
              {
                data?.files?.map((message, index) => (
                  <React.Fragment key={index}>
                    {
                      selectedGroupId ?
                        <Box display='flex' flexDirection='row' gap='8px' alignItems="flex-start">
                          <LetterAvatarsecond name={message?.userName} />
                          <Box my={0.5}>
                            {/* Name above message for groups */}
                            <Typography variant="caption" sx={{ 
                              fontWeight: 600, 
                              fontSize: '12px',
                              color: '#555',
                              ml: 1,
                              mb: 0.5,
                              display: 'block'
                            }}>
                              {message?.userName}
                            </Typography>
                            <Card sx={{ 
                              bgcolor: '#F2F1EB', 
                              p: 1.5, 
                              borderRadius: '18px 18px 18px 4px',
                              maxWidth: '70%'
                            }}>
                              <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems="center">
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>{message?.fileName}</Typography>
                                {
                                  message?.download ?
                                    <CheckCircleIcon sx={{ fontSize: '20px', color: 'green' }} />
                                    :
                                    <DownloadForOfflineIcon
                                      sx={{ fontSize: '20px', cursor: 'pointer', color: '#666' }}
                                      onClick={() => handleDownload(message?.fileContent, message?.fileName, message.messageId)}
                                    />
                                }
                              </Box>
                              <Box mt={0.5} display='flex' justifyContent='end'>
                                <Typography variant="caption" sx={{ color: '#666', fontSize: '11px' }}>
                                  {message?.dateTime ? formatMessageTime(message.dateTime) : ''}
                                </Typography>
                              </Box>
                            </Card>
                          </Box>
                        </Box>
                        :
                        <Box my={0.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <Card sx={{ 
                            bgcolor: '#F2F1EB', 
                            p: 1.5, 
                            borderRadius: '18px 4px 18px 18px',
                            maxWidth: '70%'
                          }}>
                            <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems="center">
                              <Typography variant="body2" sx={{ fontWeight: 500 }}>{message?.fileName}</Typography>
                              {
                                !message?.download ?
                                  <CheckCircleIcon sx={{ fontSize: '20px', color: 'green' }} />
                                  :
                                  <DownloadForOfflineIcon
                                    sx={{ fontSize: '20px', cursor: 'pointer', color: '#666' }}
                                    onClick={() => handleDownload(message?.fileContent, message?.fileName, message.messageId)}
                                  />
                              }
                            </Box>
                            <Box mt={0.5} display='flex' justifyContent='end'>
                              <Typography variant="caption" sx={{ color: '#666', fontSize: '11px' }}>
                                {message?.dateTime ? formatMessageTime(message.dateTime) : ''}
                              </Typography>
                            </Box>
                          </Card>
                        </Box>
                    }
                  </React.Fragment>
                ))}
            </Box>
          </Box>
        )
          :
          (
            <Box sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              bgcolor: '#f5f5f5'
            }}>
              {/* Messages Area */}
              <Box sx={{
                flex: 1,
                overflowY: 'auto',
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5
              }}>
                {AllMessage?.map((message, index) => {
                  const showDateHeader = index === 0 || isDifferentDay(message.createdAt, AllMessage[index - 1]?.createdAt);
                  
                  return (
                    <React.Fragment key={index}>
                      {/* Date Header */}
                      {showDateHeader && (
                        <Box display="flex" justifyContent="center" my={1}>
                          <Typography variant="caption" sx={{
                            bgcolor: '#e0e0e0',
                            color: '#555',
                            px: 2,
                            py: 0.5,
                            borderRadius: '12px',
                            fontSize: '12px',
                            fontWeight: 500
                          }}>
                            {formatDateHeader(message.createdAt)}
                          </Typography>
                        </Box>
                      )}

                      {/* Message */}
                      {message.userId === userId ? (
                        <SenderMessage
                          message={message}
                          handleDownload={() => handleDownload(message?.fileContent, message?.fileName, message.messageId)}
                          deleteParticularMessage={() => deleteParticularMessage(message._id)}
                          formatMessageTime={formatMessageTime}
                        />
                      ) : (
                        <Box display='flex' flexDirection='row' gap='8px' alignItems="flex-start">
                          <LetterAvatarsecond name={message.userName ? message.userName : 'Unknown'} />
                          <Box sx={{ flex: 1, maxWidth: '70%' }}>
                            {/* Show name for group chats or if different sender than previous */}
                            {(selectedGroupId || (index === 0 || message.userId !== AllMessage[index - 1]?.userId)) && (
                              <Typography variant="caption" sx={{ 
                                fontWeight: 600, 
                                fontSize: '12px',
                                color: '#555',
                                ml: 1,
                                mb: 0.5,
                                display: 'block'
                              }}>
                                {message.userName || 'Unknown'}
                              </Typography>
                            )}
                            <ReceiverMessage
                              handleDownload={() => handleDownload(message?.fileContent, message?.fileName, message.messageId)}
                              message={message}
                              formatMessageTime={formatMessageTime}
                            />
                          </Box>
                        </Box>
                      )}
                    </React.Fragment>
                  );
                })}

                {/* Audio and File Drafts */}
                {audios.length > 0 && audios[0].data &&
                  <Grid container display='flex' flexDirection='row' justifyContent='center' alignItems="center" alignContent='center'>
                    <Box component={Card} py={1.5} px={2} sx={{ mt: 1, borderRadius: '16px', bgcolor: '#F2F1EB', maxWidth: '70%' }}>
                      {audios?.map((res, index) =>
                        res.data ?
                          <div
                            key={index}
                            style={{
                              width: "100%",
                              height: 40,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-around",
                              flexDirection: "row"
                            }}
                          >
                            <div>
                              <audio controls style={{ width: '250px' }}>
                                <source src={URL.createObjectURL(res.data)} type="audio/mpeg" />
                                Your browser does not support the audio element.
                              </audio>
                            </div>
                            <Delete
                              onClick={() => {
                                HandleDialog('DraftAudio')
                                setAudioIndex(index)
                              }}
                              sx={{ cursor: 'pointer', fontSize: '24px', color: '#ff4444' }}
                            />
                          </div>
                          :
                          null
                      )}
                    </Box>
                  </Grid>
                }

                {selectedFile && selectedFile !== null &&
                  <Grid container display='flex' flexDirection='row' justifyContent='center' alignItems="center" alignContent='center'>
                    <Box component={Card} p={1.5} display='flex' flexDirection='row' gap={2} alignItems="center" sx={{ mt: 1, borderRadius: '16px', bgcolor: '#F2F1EB', maxWidth: '70%' }}>
                      <Typography variant="body2" sx={{ maxWidth: '200px', wordBreak: 'break-word' }}>
                        {selectedFileName}
                      </Typography>
                      <Delete
                        onClick={() => HandleDialog('DraftFile')}
                        sx={{ cursor: 'pointer', fontSize: '22px', color: '#ff4444' }}
                      />
                    </Box>
                  </Grid>
                }

                <div ref={dummy}></div>
              </Box>

              {/* Chat Input */}
              <Box sx={{
                mt: 'auto',
                p: 1,
                backgroundColor: 'white',
                borderTop: '1px solid #e0e0e0'
              }}>
                <ChatInput
                  handleReceiveMessage={handleReceiveMessage}
                  disable={disable}
                  setDisable={setDisable}
                  messageType={messageType}
                  setMessageType={setMessageType}
                  selectedFileName={selectedFileName}
                  setSelectedFileName={setSelectedFileName}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                />
              </Box>
            </Box>
          )
      }
    </>
  );
};

export default ChatArea;